var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[_c('v-tooltip',{attrs:{"bottom":""},scopedSlots:_vm._u([{key:"activator",fn:function({ on }){return [_c('span',_vm._g({},on),[_vm._t("default")],2)]}}],null,true)},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.texto)}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }